export default {
    methods: {
        openModal(element) {
            $('.' + element).modal({
                backdrop: 'static',
            }).modal('show')
        },
        closeModal(element) {
            $('.' + element).modal('hide')
        },
        isModalOpen(element) {
            return !!(($('.' + element).data('bs.modal') || {})._isShown)
        },
    }
}
